import { useMemo } from 'react';
import { JobObjectFailure } from '../../../interfaces/job';
import { Table } from '../../../../table/Table';
import { TableRow } from '../../../../table/interfaces/table';
import styles from './JobObjectStageFailures.module.scss';
import { ListComponentBaseProps } from '../../../../entity-list/interface';
import { jobObjectStageFailureColumns } from './JobObjectStageFailureColumns';

export function JobObjectStageFailuresTable({
  data: failures
}: ListComponentBaseProps<JobObjectFailure[]>) {
  const failureRows: TableRow<JobObjectFailure>[] = useMemo(() => {
    return failures.map(failure => ({
      data: failure,
      tabIndex: 0,
      id: failure.id
    }));
  }, [failures]);

  return (
    <Table
      classes={{ headerClass: styles.failureTableRow, rowClass: styles.failureTableRow }}
      columns={jobObjectStageFailureColumns}
      renderHeader
      withoutShadow
      compactHeader
      rows={failureRows}
      forceFullWidth
    />
  );
}
